import { motion } from "framer-motion";
import { CUSTOMERS } from "../data/content";

export const CustomerGrid = () => (
  <div className="grid grid-cols-2 sm:grid-cols-3 border-l border-t border-[var(--line)]" data-testid="customer-logo-grid">
    {CUSTOMERS.map((c, i) => (
      <motion.div
        key={c.name}
        className={`customer-cell group relative flex h-28 sm:h-36 items-center justify-center border-b border-r border-[var(--line)] bg-white/50 px-5 ${i === CUSTOMERS.length - 1 ? "col-span-2 sm:col-span-1" : ""}`}
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.7, delay: (i % 3) * 0.08 + Math.floor(i / 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
        data-testid={`customer-logo-${c.name.toLowerCase().replace(/[^a-z]/g, "")}`}
      >
        <img
          src={c.src}
          alt={`${c.name} logo`}
          loading="lazy"
          className="customer-logo h-auto max-h-12 object-contain"
          style={{ width: `min(${c.w}px, 72%)` }}
        />
      </motion.div>
    ))}
  </div>
);
